import { render, staticRenderFns } from "./sga.vue?vue&type=template&id=35b59576&"
import script from "./sga.vue?vue&type=script&lang=js&"
export * from "./sga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports